export function parseJsonObject(value: string | null | undefined): Record<string, any> {
  if (!value) return {};
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function parseJsonArray<T = any>(value: string | null | undefined): T[] {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed as T[];
    // Handle double-encoded JSON arrays (e.g. "\"[ ... ]\"")
    if (typeof parsed === 'string') {
      try {
        const nested = JSON.parse(parsed);
        return Array.isArray(nested) ? (nested as T[]) : [];
      } catch {
        return [];
      }
    }
    return [];
  } catch {
    return [];
  }
}
